import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { GeoLocationHelper } from '@laputan/helpers'
import Big from 'big.js'
import { ISchoolListingItemProp } from './SchoolListingItemProp'
import { STYLES } from '../../../static/style'
import { Text } from '../../../components/Text'
import { ThreeColumnListItem } from '../../ListItem/ThreeColumnListItem'
import { CONFIG } from '../../../config'
import { showModal } from '../../../states/modals/actions'
import { ModalType } from '../../../states/modals/ModalType.constants'

const TitleText = styled(Text)`
  font-size: ${STYLES.FONT_SIZE_MD};
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  overflow: hidden;
  line-height: 1rem;
  height: 1.2rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
`

const CategoryImage = styled.img`
  width: 2.6rem;
  height: 2.6rem;
  margin-right: ${STYLES.GUTTER};
  display: block;
`

const StyledSchoolListingItem = styled(ThreeColumnListItem)`
  display: flex;
  > div > div {
    width: 100%; // don't remove this as it will break the activity content
  }
`

const ThreeColumnListItemLeft = styled.div``

const ThreeColumnListItemRight = styled.div`
  flex: 1;
  overflow: hidden;
  text-align: left;
`

const TopContent = styled.div``

const BottomContent = styled.div`
  display: flex;
`

const CategoryText = styled(Text)`
  flex: 1;
  font-size: ${STYLES.FONT_SIZE_SM};
`

const LocationText = styled(Text)`
  font-size: ${STYLES.FONT_SIZE_XS};
  color: ${STYLES.COLOR_PALE_SKY_GRAY};
`

interface ISchoolListingItemProps {
  className?: string
  schoolCoords: Array<number>
  listing: ISchoolListingItemProp
}

const SchoolListingItem: React.FC<ISchoolListingItemProps> = ({
  className,
  schoolCoords,
  listing,
}) => {
  const { title, categories, location } = listing
  const { coords } = location
  const dispatch = useDispatch()
  const distanceInKm = Big(
    GeoLocationHelper.getDistanceFromLatLonInKm({
      from: {
        lat: schoolCoords[1],
        lng: schoolCoords[0],
      },
      to: {
        lat: coords[1],
        lng: coords[0],
      },
    })
  ).toPrecision(2)

  const [{ image }] = categories
  const categoryText = categories.map(({ name }) => name).join(', ')
  return (
    <StyledSchoolListingItem
      className={className}
      onClick={() =>
        dispatch(showModal(ModalType.SCHOOL_LISTING_DETAILS_MODAL, listing))
      }
    >
      <ThreeColumnListItemLeft>
        <CategoryImage src={`${CONFIG.LAPUTAN_IMAGE_SERVER_URL}/${image}`} />
      </ThreeColumnListItemLeft>
      <ThreeColumnListItemRight>
        <TopContent>
          <TitleText>{title}</TitleText>
        </TopContent>
        <BottomContent>
          <CategoryText>
            {title !== categoryText &&
              categories.map(({ name }) => name).join(', ')}
          </CategoryText>
          <LocationText>{`${distanceInKm}km`}</LocationText>
        </BottomContent>
      </ThreeColumnListItemRight>
    </StyledSchoolListingItem>
  )
}

export { SchoolListingItem }
